import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';

const MediaError = ({ history, mediaError }) => {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
        <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: '32px 40px', maxWidth: 480, textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>&#128247;</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#991b1b', marginBottom: 8 }}>{t('screens.video.group.mediaErrorTitle')}</div>
          <div style={{ fontSize: 14, color: '#b91c1c', lineHeight: 1.6 }}>{mediaError}</div>
          <button
            onClick={() => history.push('/chat')}
            style={{
              marginTop: 24,
              padding: '10px 24px',
              background: '#7c3aed',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {t('screens.video.group.backToChat')}
          </button>
        </div>
      </div>
    </AppLayout>
  );
};

export default MediaError;
